import React from 'react';
import '../../../styles/Home.css';
import { Link } from 'react-router-dom';

const PeerReview = (props) => {
    const JournalID =  props.data
    console.log("TEST")
    console.log(JournalID)
    
    // JournalID == "412" || JournalID == "2" || JournalID == "3" || JournalID == "680" || JournalID == "672"

    if (JournalID == "412" || JournalID == "680" || JournalID == "672") {
        return (
            
        <div><div
                    className="TopicBorder BGGrey"
                    id="Subcribeto"
                    style={{
                        borderTop: "2px solid #CCCCCC",
                        paddingBottom: "3%",
                        paddingTop: "3%",
                        fontSize: "18px",
                    }}
                >
                    <span className="paddingL fontbold margintop SetPaddingforP">
                        {" "}
                        Contribute to this journal{" "}
                    </span>
                </div>
                <div className="TopicBorder" id="Pricemenu">
                    <p
                        className="paddingL fontbold"
                        style={{ lineHeight: "3", marginBottom: "3%" }}
                    >
                        Go Directly to PeerEase!
                        <Link
                           to={{ pathname: "https://peerease.integra.co.in/" }} target="_blank"
                            variant="primary"
                            style={{ marginTop: "3%", textAlign: "center" }}
                            className="Modalbutton-secondary Setwdth HoverUnderline"
                        >
                            {" "}
                            <strong> Submit Article</strong>{" "}
                        </Link>
                    </p>
                </div>
            </div>
        )
    }
    else {
        return (
            <div></div>
        )
    }

}

export default PeerReview;


// WEBPACK FOOTER //
// ./src/components/Journals/Subitems/PeerReview.jsx